/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s,o){this.query=t,this.flowPaths=s,this.flowData=o}}export{t as AFlowResources};
